import wordmark1x from "./assets/logo-wordmark-594.webp";
import wordmark2x from "./assets/logo-wordmark-1188.webp";

interface WordmarkProps {
  /** Rendered width in CSS pixels. Height follows the logo's 594:162 ratio. */
  width?: number;
  className?: string;
}

const RATIO = 162 / 594;

/**
 * ThyroAID wordmark. The only supplied logo has a maroon background baked in (BRAND-004),
 * so place this on `--surface-chrome` only — never on light surfaces.
 */
export function Wordmark({ width = 180, className }: WordmarkProps) {
  return (
    <img
      src={wordmark1x}
      srcSet={`${wordmark1x} 1x, ${wordmark2x} 2x`}
      width={width}
      height={Math.round(width * RATIO)}
      alt="ThyroAID"
      className={className}
      decoding="async"
    />
  );
}
